var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 16,
    viewBox: "0 0 55 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6786 7.04365V15.5818H44.422V10.5222H49.7979C52.0589 10.5063 53.98 9.05961 54.7073 7.04365H39.6786Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0463 0.00786207C39.323 3.49427 42.6276 6.25336 46.6595 6.25336H54.9052C54.9684 5.93713 55 5.60509 55 5.26515C55 2.37166 52.6679 0.0315791 49.7823 0.00786207H39.0463Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0258 6.1664C32.0812 6.07153 32.1682 6.01619 32.2788 6.01619C32.4369 6.01619 32.5555 6.14268 32.5634 6.29289V15.503H37.3069V0.00786207H32.5634C31.9626 0.0315791 31.2827 0.466392 31.0297 1.01188L27.2587 9.10731C27.2508 9.13894 27.235 9.17056 27.2192 9.20218C27.1638 9.28124 27.069 9.33658 26.9583 9.33658C26.7844 9.33658 26.6421 9.19428 26.6421 9.02035V0.00786207H21.8987V15.503H26.6421C27.235 15.4714 27.8991 15.0366 28.1521 14.499L32.0258 6.19011C32.0179 6.18221 32.0258 6.1743 32.0258 6.1664Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3172 6.43523L11.5423 15.5031H8.12705L5.36006 6.42733C5.33634 6.28502 5.20985 6.17435 5.05174 6.17435C4.87781 6.17435 4.74341 6.31665 4.74341 6.48267V15.4952H0V0H5.281C6.15063 0 7.06769 0.67989 7.32067 1.50999L9.62913 9.05992C9.74772 9.43939 9.92955 9.43149 10.0481 9.05992L12.3566 1.50999C12.6096 0.671984 13.5266 0 14.3963 0H19.6773V15.4952H14.9339V6.48267C14.9339 6.48267 14.9339 6.48267 14.9339 6.47476C14.9339 6.30084 14.7915 6.16644 14.6255 6.16644C14.4674 6.17434 14.3409 6.28503 14.3172 6.43523Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/мир.c8ef1085dd8c446a12737d36ff54a83c.svg";
export { ForwardRef as ReactComponent };